export enum SourceObjectTypeEnum {
    Category = 0,
    Tax = 1,
    Customer = 2,
    Requisition = 3,
    RequisitionChartOfAccount = 4
}